import { createAxiosClient } from "@ntg/component-library/utilities";

export interface IRouteOperationD365 {
    dataAreaId: string;
    routeId: string;
    operationNumber: number;
    operationId: string;
    operationPriority: number;
    nextRouteOperationNumber: number;
}

export const getRouteOperationsByRouteD365 = async (
    routeId: string,
    dataAreaId: string,
): Promise<IRouteOperationD365[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<IRouteOperationD365[]>(
        `/RouteOperation/GetRouteOperationsByRouteD365`,
        { params: { routeId, dataAreaId } },
    );
    return response.data ?? [];
};
